import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { apiClient } from "@/services/ApiService.js";
import VueSweetalert2 from "vue-sweetalert2";
import swal from "sweetalert2/dist/sweetalert2.all.min.js";

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);

const token = localStorage.getItem("token");
if (token) {
  apiClient.defaults.headers.common["Authorization"] = "Bearer " + token;
}
//else {
//apiClient.defaults.headers["Content-Type"] =
//  "application/x-www-form-urlencoded";
//}

apiClient.interceptors.response.use(
  response => {
    // intercept the global error
    return response;
  },
  function(error) {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      // No redirigir al login si estamos en la página de reset de contraseña
      const currentPath = window.location.pathname;
      if (currentPath === "/reset-password") {
        return Promise.reject(error);
      }
      console.log("intercepta", error);
      store.commit("SET_LOADING", false);
      store.commit("AUTH_LOGOUT");
      router.push("/login");
    }
    if (error.response.status === 404 && !originalRequest._retry) {
      originalRequest._retry = true;
      return;
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
